import React, { useEffect, useState } from 'react';
import { Pagination, Table, Tag, Space } from 'antd';
import HeaderComponent from '../../components/Header';
import { useNavigate } from 'react-router-dom';
import CreateNewOnboardingRequest from './CreateNewOnboardingRequest';
import { getApi } from '../../services/api';

const columns = [
	{
		title: 'Name',
		dataIndex: 'name',
		key: 'name',
		render: (text) => <a>{text}</a>,
	},
	{
		title: 'Age',
		dataIndex: 'age',
		key: 'age',
	},
	{
		title: 'Address',
		dataIndex: 'address',
		key: 'address',
	},
	{
		title: 'Tags',
		key: 'tags',
		dataIndex: 'tags',
		render: (_, { tags }) => (
			<>
				{tags.map((tag) => {
					let color = tag.length > 5 ? 'geekblue' : 'green';
					if (tag === 'loser') {
						color = 'volcano';
					}
					return (
						<Tag color={color} key={tag}>
							{tag.toUpperCase()}
						</Tag>
					);
				})}
			</>
		),
	},
	{
		title: 'Action',
		key: 'action',
		render: (_, record) => (
			<Space size="middle">
				<a>Invite {record.name}</a>
				<a>Delete</a>
			</Space>
		),
	},
];

const data = [
	{
		key: '1',
		name: 'John Brown',
		age: 32,
		address: 'New York No. 1 Lake Park',
		tags: ['nice', 'developer'],
	},
	{
		key: '2',
		name: 'Jim Green',
		age: 42,
		address: 'London No. 1 Lake Park',
		tags: ['loser'],
	},
	{
		key: '3',
		name: 'Joe Black',
		age: 32,
		address: 'Sydney No. 1 Lake Park',
		tags: ['cool', 'teacher'],
	},
];

const PreEmployeeOnboarding = () => {
	const navigate = useNavigate();
	const [onboardRequests, setOnboardingRequests] = useState([]);
	const [pagination, setPagination] = useState({ current: 1, total: 10, pageSize: 10 });

	useEffect(() => {
		const getOnboardingRequest = async function () {
			const resp = await getApi(
				`/assetze/emp-pre-onboarding?page=${pagination.current}&pageSize=${pagination.pageSize}`
			);
			if (resp.type === 'success') {
				setOnboardingRequests(resp.data);
			}
		};
		getOnboardingRequest();
	}, []);

	const onTableChange = (values) => {
		console.log('onTableChange', values);
		const getOnboardingRequest = async function () {
			const resp = await getApi(`/assetze/emp-pre-onboarding?page=${values.current}&pageSize=${values.pageSize}`);
			if (resp.type === 'success') {
				setOnboardingRequests(resp.data);
				setPagination({ ...pagination, current: values.current, pageSize: values.pageSize });
			}
		};
		getOnboardingRequest();
	};

	return (
		<div className="error-page-container">
			<HeaderComponent />
			<div>
				<CreateNewOnboardingRequest />
				{/* <Table onChange={onTableChange} pagination={pagination} columns={columns} dataSource={data} /> */}
			</div>
		</div>
	);
};

export default PreEmployeeOnboarding;
